'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var PersonOutline = {};

exports.__exports = PersonOutline;
